import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsStaggered } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import Button from 'elements/Button';

type Props = {
  onClick: () => void;
  className?: string;
};

// The hamburger menu toggle. Used by the settings header. The dashboard uses
// LeftButton (box icon) instead.
const MenuButton: React.FC<Props> = ({ onClick, className }) => {
  return (
    <div className={styles.container(className)}>
      <Button
        type="button"
        variant="ghost"
        color="neutral"
        noAnimation
        aria-controls="mobile-menu"
        aria-expanded="false"
        onClick={onClick}
        className={`${styles.btn.container} hover:bg-white rounded-none min-h-0 focus:ring-0 focus:ring-offset-0`}
      >
        <FontAwesomeIcon
          icon={faBarsStaggered}
          className={styles.btn.icon}
          size="lg"
        />
      </Button>
    </div>
  );
};

export default MenuButton;

const styles = {
  container: (className: string) => classNames('flex items-center', className),
  btn: {
    container: classNames(
      'bg-white inline-flex items-center justify-center p-2 text-gray-400',
      'scale-x hover:scale-x-[-1]',
    ),
    icon: 'fa-fw text-[#161E3A]',
  },
};
